import React from "react"
import PropTypes from "prop-types"
import { Modal, ModalBody } from "reactstrap"

const DraftSuccessModal = ({ isOpen, toggle }) => {
  return (
    <Modal 
      isOpen={isOpen} 
      toggle={toggle} 
      centered
      style={{ borderRadius: "12px" }}
    >
      <ModalBody 
        className="px-4 py-4"
        style={{ borderRadius: "12px" }}
      >
        <div className="d-flex align-items-center gap-3 mb-4">
          <i 
            className="bx bx-check-circle"
            style={{ 
              fontSize: "24px", 
              color: "#34c38f"
            }}
          ></i>
          <p 
            className="mb-0"
            style={{ 
              fontSize: "16px", 
              fontWeight: "500",
              color: "#000"
            }}
          >
            Order saved as draft
          </p>
        </div>
        
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn"
            style={{
              backgroundColor: "#34c38f",
              border: "1px solid #34c38f",
              color: "#fff",
              borderRadius: "8px",
              minWidth: "100px",
              padding: "8px 24px"
            }}
            onClick={toggle}
          >
            Close
          </button>
        </div>
      </ModalBody>
    </Modal>
  )
}

DraftSuccessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default DraftSuccessModal
